var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#57454A",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 3.27002H2.99062C1.34062 3.27002 0 4.65772 0 6.36123V43.0538C0 44.7573 1.34062 46.145 2.99062 46.145H39C40.65 46.145 42 44.7573 42 43.0538V6.36123C42 4.65772 40.65 3.27002 39 3.27002ZM12.6937 40.02H6.46875V19.5587H12.7031V40.02H12.6937ZM9.58125 16.7642C7.58437 16.7642 5.97188 15.1085 5.97188 13.0796C5.97188 11.0507 7.58437 9.39502 9.58125 9.39502C11.5687 9.39502 13.1906 11.0507 13.1906 13.0796C13.1906 15.1181 11.5781 16.7642 9.58125 16.7642ZM36.0281 40.02H29.8031V30.0669C29.8031 27.6935 29.7562 24.6405 26.5687 24.6405C23.325 24.6405 22.8281 27.2245 22.8281 29.8946V40.02H16.6031V19.5587H22.575V22.3532H22.6594C23.4937 20.7454 25.5281 19.0515 28.5563 19.0515C34.8563 19.0515 36.0281 23.2911 36.0281 28.8036V40.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1a779ea84fee7157c42e74aa72b5806c.svg";
export { ForwardRef as ReactComponent };